/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_CycleInputs */

const cs_dashboard_kpi_cycle = /** @type {(inputs: Dashboard_Kpi_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prům. cyklus (dny)`)
};

const en_dashboard_kpi_cycle = /** @type {(inputs: Dashboard_Kpi_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg. cycle (days)`)
};

/**
* | output |
* | --- |
* | "Avg. cycle (days)" |
*
* @param {Dashboard_Kpi_CycleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_cycle = /** @type {((inputs?: Dashboard_Kpi_CycleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_CycleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_cycle(inputs)
	return cs_dashboard_kpi_cycle(inputs)
});